class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (section.id == 'cart-drawer') {
        if (document.querySelector('.drawer__inner-empty')) {
          document.querySelector('.drawer__inner-empty').remove();
          document.querySelector('cart-drawer-items').classList.remove("is-empty");
        }
        const drawerHeader = document.querySelector('.drawer__header');
        drawerHeader.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], '.drawer__header');
        const drawerItems = document.querySelector('cart-drawer-items');
        drawerItems.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], 'cart-drawer-items');
        const drawerFooter = document.querySelector('.drawer__footer');
        drawerFooter.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], '.drawer__footer');
        // update free shipping progress bar
        setTimeout(() => {
          var total_price = document.querySelector('.cart-drawer .totals__subtotal-value').dataset.subtotal;
          total_price =  total_price / 100;
          total_price = total_price.toFixed(2);
          console.log(total_price);
          var free_shipping_limit = 50;
          if (document.querySelector('.cart-drawer .cart-bar-container')) {
            free_shipping_limit = document.querySelector('.cart-drawer .cart-bar-container').dataset.limit;
            if(parseInt(total_price) >= free_shipping_limit){
              document.querySelector('.cart-drawer .bar-progress').style.width = '100%';
              document.querySelector('.cart-drawer .cart-bar-container .bar-text p').innerHTML = 'You qualify for FREE shipping!';
            }else {
              var percent=(total_price*100)/free_shipping_limit;
              document.querySelector('.cart-drawer .bar-progress').style.width = percent+'%';
              document.querySelector('.cart-drawer .cart-bar-container .bar-text p').innerHTML = 'You are only $'+(free_shipping_limit-total_price).toFixed(2)+' away from FREE shipping!';
            }
          }
        }, 800);
      }
      else {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    }, 2000);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
